import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Url } from "../../Services/Api";
import testingImg from "../../Assets/testingimg.webp"
import { FaArrowLeftLong } from "react-icons/fa6";

export default function ViewRenderedBlog() {
    const { id } = useParams(); // Get :id from URL
    const location = useLocation();
    const navigate = useNavigate();

    // Data passed from previous page
    const blogData = location.state || null;

    const [blog, setBlog] = useState(blogData);

    useEffect(() => {
        console.log(blogData)
    }, [blogData])


    return (
        <div className="view_rendered_blog_main_container">
            <div style={{
                display:"flex",
                alignItems:"flex-start",
                justifyContent:"flex-start",
                gap:"10px"
            }}>
                <div
                    className="blog_qview_back_button"
                    onClick={() => navigate(-1)}
                >
                    <FaArrowLeftLong size={24} />
                </div>
                <h2 className="render_view_blog_heading">{blog?.title}</h2>
            </div>
            {blog?.image?.image_url !== "" && <img className="blogMainImage" src={Url + blog?.image?.image_url} alt="" srcset="" />}
            <div
                dangerouslySetInnerHTML={{
                    __html: blog?.content || "",
                }}
            />
        </div>
    );
}